import React from "react";
import "./esim-share.scss";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { Button } from "antd";

const EsimShare = () => {
  return (
    <>
      <Navbar />

      <div className="top-bar">
        <div className="top-bar-left">
          <div className="mini-logo"></div>
          <div className="text">
            <div className="title">Teleport Now</div>
            <div className="desc">Open in App</div>
          </div>
        </div>

        <Button type="primary" size="small" className="top-open-btn">
          Open
        </Button>
      </div>

      <div className="share-page">
        <div className="share-card">
          <div className="logo-section">
            <div className="logo-placeholder"></div>
            <div className="app-name">Teleport Now</div>
            {/* <div className="app-desc">Open in App</div> */}
          </div>

          <Button type="primary" className="open-btn">
            Open Teleport Now App
          </Button>

          <div className="helper-text">
            <div>Having trouble opening? Try your default browser.</div>
            <a href="">Copy the link</a>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default EsimShare;
